import * as React from 'react'

import { type Props } from '#app/components/payment-icons'

const InvoiceSign: React.FC<Props> = (props) => (
	<svg
		{...props}
		viewBox="0 0 2048 1329.1012"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M1095.066 318.1c-.066.945-.104 2.047-.104 3.157 0 13.957 5.94 26.526 15.432 35.317l.03.03c9.077 9.473 21.83 15.36 35.96 15.36.174 0 .348 0 .522-.002h297.547v579.79c.03.616.046 1.34.046 2.066 0 13.648-5.935 25.91-15.363 34.35l-.044.038c-9.076 9.474-21.83 15.362-35.96 15.362-.173 0-.347 0-.52-.003H655.358c-.148.002-.322.002-.496.002-14.13 0-26.883-5.888-35.942-15.345l-.017-.018c-9.473-8.442-15.41-20.677-15.41-34.3 0-.757.017-1.51.054-2.26l-.005.106V72.34c-.032-.644-.05-1.398-.05-2.156 0-13.622 5.936-25.857 15.364-34.26l.045-.04c9.076-9.473 21.83-15.36 35.96-15.36.173 0 .347 0 .52.002h439.68zm69.222-17.202V41.008c7.218 5.192 13.49 10.23 19.49 15.57l-.24-.21 225.28 225.28c5.124 5.758 10.162 12.03 14.88 18.55l.48.7z" />
	</svg>
)

export { InvoiceSign }
